<template><div><h1>VUX V2.1.1Rc.6 released</h1>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix wrong setting of overflow-scrolling when using multi popup on Safari #1015 @think2011</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[fix] fix forbidden style being overwritten #1016 @LaiXuechao</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.6 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.6-86.vue?06d6ec67